import { render, staticRenderFns } from "./IssueVars.vue?vue&type=template&id=bb83a25c&scoped=true&"
import script from "./IssueVars.vue?vue&type=script&lang=js&"
export * from "./IssueVars.vue?vue&type=script&lang=js&"
import style0 from "./IssueVars.vue?vue&type=style&index=0&id=bb83a25c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb83a25c",
  null
  
)

export default component.exports